import React from 'react';
import { Avatar } from '@material-ui/core';
import { themePalette } from '../../utilities/branding';
import { SimpleListItem } from '../utility/simple_list_item';
import { useLinkToExternal } from '../../utilities/hooks';

interface Props {
	id: string;
	name: string;
	description: string | null;
	learnMore: string | null;
	url: string;
	isSSO: boolean;
	hideDescription?: boolean;
}

export const ToolItem: React.FC<Props> = (props: Props) => {
	
	const { name, url, hideDescription, description, id } = props;
	const openLink = useLinkToExternal(url);

	return (
		<SimpleListItem
			key={id}
			title={name}
			subtitle={hideDescription ? null : description}
			onClick={openLink}
			hideArrow
			icon={
				<Avatar
					color={themePalette.negative_text}
					style={{ backgroundColor: themePalette.tools_avatar }}
				>
					{name.charAt(0)}
				</Avatar>
			}
		/>
	);
};
